import type { QueryClient } from '@tanstack/react-query';
import { profileKeys } from '../hooks/useProfile';
import { clientsKeys } from '../hooks/useClients';

/**
 * После создания/изменения задачи обновляет все связанные запросы,
 * чтобы списки и счётчики подтянулись без полной перезагрузки страницы.
 */
export async function invalidateTaskRelatedQueries(queryClient: QueryClient): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: ['tasks'], exact: false, refetchType: 'all' }),
    queryClient.invalidateQueries({ queryKey: ['task'], exact: false, refetchType: 'all' }),
    queryClient.invalidateQueries({ queryKey: ['clientProjects'], exact: false, refetchType: 'all' }),
    queryClient.invalidateQueries({ queryKey: ['projects'], exact: false, refetchType: 'all' }),
    queryClient.invalidateQueries({ queryKey: ['projectsArchive'], exact: false, refetchType: 'all' }),
    queryClient.invalidateQueries({ queryKey: ['projectsStatistics'], exact: false, refetchType: 'all' }),
    queryClient.invalidateQueries({ queryKey: ['projectsManagersSource'], exact: false, refetchType: 'all' }),
    queryClient.invalidateQueries({ queryKey: ['projectsArchiveManagersSource'], exact: false, refetchType: 'all' }),
    queryClient.invalidateQueries({ queryKey: [...profileKeys.all, 'statistics'], exact: false, refetchType: 'all' }),
    queryClient.invalidateQueries({ queryKey: clientsKeys.statistics(), refetchType: 'all' }),
  ]);
}
